export function getGridPagingParams(sortOrder, sortBy, pageSize = 50) {
  return {
    pageNumber: 1,
    pageSize: pageSize,
    sortOrder: sortOrder,
    tItems: 0,
    totalPages: 0,
    searchValue: "",
    sortBy: sortBy,
    totalItems: 0,
    filters: {},
  };
}

export function mapGridPagingState(pagingState, pagingData) {

  ['filters', 'sortBy', 'sortOrder', 'totalItems', 'pageSize', 'pageNumber'].map(key => {

    if (pagingData && pagingData.hasOwnProperty(key)) {
      pagingState[key] = pagingData[key];
    }

  });

  return pagingState;
}

export function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

//find objects in array  by property
export function findObjectsByPropertyInArray(array, propertyName, value) {
  if (array === null || array === undefined || array.length === 0) {
    return null
  }

  return array.filter((obj, idx) => {
    return obj[propertyName] === value
  })
}

//find index of object from array of object
export function findIndexFromArrayOfObject(array, propertyName, value) {
  let index;
  array && array.some(function (entry, idx) {
    if (entry[propertyName] === value) {
      index = idx
      return true
    }
  })
  return index
}

//FIND SINGLE OBJECT BY PROPERTY NAME IN ARRAY - CASE IN-SENSITIVE WAY
export function findObjectByPropertyNameInArray(array, propertyName, value) {
  if (array === null || array === undefined || array.length === 0) {
    return null
  }
  for (let i = 0; i < array.length; i++) {
    if (array[i][propertyName] !== undefined) {
      if ((array[i][propertyName].toString()).toLowerCase() === value.toLowerCase()) {
        return array[i]
      }
    }
  }
  return null
}

// remove time from date and return date in format MM/DD/YYYY
export function removeTimeFromDate(dateValue) {
  let updatedDateVal = '';
  let month = '';
  let day = '';


  if (!_.isEmpty(dateValue)) {
    let splitDate = dateValue.split('T')
    let date = new Date(splitDate[0].replace(/-/g, '/'))

    if (date.toLocaleString() === "Invalid Date") {
      splitDate = splitDate[0].replace(/-/g, '/')
      let splitAgain = splitDate.split('/');
      let mmddyyyyFormateDate = splitAgain[1] + '/' + splitAgain[0] + '/' + splitAgain[2];

      date = new Date(mmddyyyyFormateDate)
    }

    month = '' + (date.getMonth() + 1)
    day = '' + date.getDate()

    if (month.length < 2) month = '0' + month

    if (day.length < 2) day = '0' + day

    // updatedDateVal = month + '-' + day + '-' + date.getFullYear().toString().substr(-2);
    updatedDateVal = month + '-' + day + '-' + date.getFullYear().toString();
  }

  return updatedDateVal;
}

//validate two dates eg. start date and end date
export function validateTwoDates(startDateVal, endDateVal) {

  let startDate = new Date(startDateVal);
  let endDate = new Date(endDateVal);

  //separate the year,month and day for the first date
  let strYear1 = startDate.getFullYear();
  let strMonth1 = startDate.getMonth();
  let strDay1 = startDate.getDate();
  let date1 = new Date(strYear1, strMonth1, strDay1);

  //separate the year,month and day for the second date
  let strYear2 = endDate.getFullYear();
  let strMth2 = endDate.getMonth();
  let strDay2 = endDate.getDate();
  let date2 = new Date(strYear2, strMth2, strDay2);

  let dateDiffVal = (date2 - date1) / 864e5;

  if (dateDiffVal <= 0) {
    return false;
  }
  return true;
}

//convert to from select obj for drop down
export function convertToFormSelectObj(arr, { value, text }) {
  let convertedObjArr = [];

  arr.forEach(a => {
    if (a[text] != '') {
      convertedObjArr.push({ value: a[value], text: a[text] });
    }
  });

  // let convertedObj = this.arr.map(a => ({ value: a[value], text: a[text] }) );

  return convertedObjArr;
}